export default "__VITE_ASSET__a90b96f0__"